import { ComponentProps } from 'react';
import { ControlledMultiSelectFieldEditorPopover } from './controlled-multi-select-field-editor-popover';
import { withFocusableSelect } from '../components/with-focusable-select';

export const MultiSelectFieldEditorPopover = withFocusableSelect<
  number[],
  ComponentProps<typeof ControlledMultiSelectFieldEditorPopover>
>(ControlledMultiSelectFieldEditorPopover);
